import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import Shop from './components/Shop';
import ProductDetail from './components/ProductDetail';
import Contact from './components/Contact';
import CartPreview from './components/CartPreview';
import FontLoader from './components/FontLoader.tsx';
import { CartProvider } from './components/CartContext';
import './styles/global.css';

function App() {
  useEffect(() => {
    document.title = "Reid Perfume"; // Change the page title for all pages
  }, []);

  return (
    <CartProvider>
      <Router>
        <FontLoader />
        <div className="app">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/cart-preview" element={<CartPreview />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;